import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { PluginPanelContainer } from './shared/PluginPanelContainer';
export function SidebarSlot() {
    return (_jsx(SidebarSlotRoot, { children: _jsx(Content, { children: _jsx(PluginPanelContainer, { slotId: "sidebar" }) }) }));
}
const Content = styled.div `
    position: absolute;
    top: 0%;
    height: 100%;
    left: 0%;
    right: 1.5rem;
    overflow: hidden;

    background: rgba(128, 128, 128, 0.3);
    border: 1px solid rgba(222, 222, 222, 0.05);
    box-shadow: inset 0px 0px 2px rgba(255, 255, 255, 0.8);
    border-radius: 24px;

    iframe {
        width: 100%;
        height: 100%;
        background: none;
    }
`;
const SidebarSlotRoot = styled.div `
    height: 100%;
    position: relative;
`;
